export default __webpack_public_path__ + "static/media/nav_nachos@2x.6f81b10f.png";